function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 17.5703C0 16.7419 0.67157 16.0703 1.5 16.0703H46.5781C47.4066 16.0703 48.0781 16.7419 48.0781 17.5703V20.0547H60.0403C61.2259 20.0547 62.3003 20.7529 62.7818 21.8363L68 33.5773V46.4453C68 47.2737 67.3284 47.9453 66.5 47.9453H59.6886C58.8662 50.264 56.6518 51.9297 54.0547 51.9297C51.4575 51.9297 49.2432 50.264 48.4208 47.9453H23.5636C22.7412 50.264 20.5268 51.9297 17.9297 51.9297C16.4001 51.9297 15.0036 51.3514 13.9453 50.403C12.8871 51.3516 11.4905 51.9297 9.96094 51.9297C6.66546 51.9297 3.98438 49.2486 3.98438 45.9531C3.98438 43.9458 4.9802 42.1677 6.50263 41.0833H1.5C0.671577 41.0833 0 40.4117 0 39.5833V17.5703ZM62.9424 32.0078L59.6646 24.6329C59.5041 24.2718 59.146 24.0391 58.7508 24.0391H54.7188V32.0078H62.9424ZM54.0547 47.9453C55.1532 47.9453 56.0469 47.0516 56.0469 45.9531C56.0469 44.8546 55.1532 43.9609 54.0547 43.9609C52.9562 43.9609 52.0625 44.8546 52.0625 45.9531C52.0625 47.0516 52.9562 47.9453 54.0547 47.9453ZM23.9062 43.9609H44.0938V41.0833H23.9062V43.9609ZM17.9297 47.9453C19.0282 47.9453 19.9219 47.0516 19.9219 45.9531C19.9219 44.8546 19.0282 43.9609 17.9297 43.9609C16.8312 43.9609 15.9375 44.8546 15.9375 45.9531C15.9375 47.0516 16.8312 47.9453 17.9297 47.9453ZM9.96094 47.9453C11.0594 47.9453 11.9531 47.0516 11.9531 45.9531C11.9531 44.8546 11.0594 43.9609 9.96094 43.9609C8.86245 43.9609 7.96875 44.8546 7.96875 45.9531C7.96875 47.0516 8.86245 47.9453 9.96094 47.9453Z",
  fill: "url(#paint0_linear_107_76)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_107_76",
  x1: 0.00000146443,
  y1: 34,
  x2: 68,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})));

var SvgTruck1 = function SvgTruck1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruck1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/truck 1.1496656a.svg";
export { ForwardRef as ReactComponent };